<template>
  <AllegroJsonForm
    title="Edytuj osobę odpowiedzialną Allegro"
    crumbLabel="Edycja osoby odpowiedzialnej"
    :settingsCrumb="true"
    submitAction="updateAllegroResponsibleProducer"
    submitGetter="getAllegroResponsibleProducerUpdateData"
    loadAction="getAllegroResponsibleProducer"
    loadGetter="getAllegroResponsibleProducerData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroResponsibleProducerPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroResponsibleProducerUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroResponsibleProducerPermissionsConst.update,
      fields: [{ key: "name", label: "Nazwa własna", required: true }],
    };
  },
};
</script>
